module.exports = __webpack_public_path__ + "static/media/dhl_icon.34a75f44.png";